import React from 'react';
import style from './Metrics.css';

const Metrics = () => {
    return (
        <div>
            <h3>
                Save time, sell more!
            </h3>
            <div className={"metrics"}>
                <div className={'sides'}>
                    <h5>
                        35 hrs
                    </h5>
                    <span>
                        lost per dealer weekly finding vehicles<sup>1</sup>
                    </span>
                </div>
                <div className={'center'}>
                    <h5>
                        {'>'}$10k
                    </h5>
                    <span>
                        lost per dealer weekly in sales<sup>2</sup>
                    </span>
                </div>
                <div className={'sides'}>
                    <h5>
                        76%
                    </h5>
                    <span>
                        of clients feel buying cars takes too long<sup>3</sup>
                    </span>
                </div>
            </div>
            {/*<div className={'sources'}>*/}
            {/*    <p>*/}
            {/*        1. Assuming a dealership of 10 salespeople with 3 cars taken out per day*/}
            {/*    </p>*/}
            {/*    <p>*/}
            {/*        2. Assuming 0.5 cars sales lost per day per employee, an average profit per car of $3,000 and a close rate of 12.4%*/}
            {/*    </p>*/}
            {/*    <p>*/}
            {/*        3. Source: IPSOS*/}
            {/*    </p>*/}
            {/*</div>*/}
        </div>
    );
};

export default Metrics;